(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9462],{

/***/ 89451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/mobile",
      function () {
        return __webpack_require__(74869);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59183);
/* harmony import */ var _components_FAQ__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22288);
/* harmony import */ var components_SignatureLtd_Legal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33376);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43138);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10447);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86585);













const bgColors = (/* unused pure expression or super */ null && ([
    "bg-green-100",
    "bg-yellow-100",
    "bg-red-100",
    "bg-gray-100",
    "bg-blue-100",
    "bg-purple-100",
    "bg-indigo-100"
]));
const gettingStarted = [
    {
        title: "Install the app",
        data: [
            "Search for “BoloSign” in the Play Store/Apple Store.",
            "Install the app."
        ]
    },
    {
        title: "Upload the Document",
        data: [
            "Upload the document that you want to send for signatures.",
            "Add the Signers."
        ]
    },
    {
        title: "Send for Signature",
        data: [
            "Add the necessary fields.",
            "Send the document for signature."
        ]
    }
];
const features = [
    {
        image: "action-1.png",
        title: "Drag and Drop Fields",
        description: 'Click the <div class="w-fit h-fit px-2 inline-block bg-gradient-to-r from-violet-500 to-blue-500 text-white rounded-full font-sans">+</div> Fields button and place signatures, initials, stamps, text, and more exactly where needed.'
    },
    {
        image: "action-2.png",
        title: "Send Reminders to Signers",
        description: 'With just one tap, send reminders to signers and keep your workflow on track.\n    <ul class="mt-2 ml-6 list-disc">\n      <li>Boost Completion Rates</li>\n      <li>Reduce Delays</li>\n      <li>Stay Updated with Real-Time Notifications</li>\n    </ul>\n    '
    },
    {
        image: "action-3.png",
        title: "Select Who Needs to Sign",
        description: 'Choose how you want to collect signatures:\n    <ul class="mt-2 ml-6 list-disc">\n      <li>Sign It Yourself – Instantly sign your document</li>\n      <li>Send for Signature – Invite others via email</li>\n      <li>In-Person Signing – Get signatures on the spot</li>\n    </ul>'
    },
    {
        image: "action-4.png",
        title: "Sign Anytime, Anywhere",
        description: "Generate Signing links, send the document, and get it signed anytime, anywhere without any delay."
    },
    {
        image: "action-5.png",
        title: "Certificate of Completion",
        description: "To ensure the signed document's legality and security, the signers can download a certificate with the timestamps and other details. Meet Global eSignature Standards (ESIGN, UETA, etc.)"
    },
    {
        image: "action-6.png",
        title: "Wide Ranged Integrations",
        description: "Upload and save your PDFs from various players like Dropbox, Google Drive, Microsoft OneDrive, Box etc"
    },
    {
        image: "action-7.png",
        title: "Guides and Resources",
        description: 'Learn the best practices for using BoloSign to streamline your document signing process.<br><a class="underline" href="https://help.boloforms.com/en/collections/15429283-how-do-you-use-the-bolosign-mobile-app-iphone-android" target="_blank">Explore More Guides</a>'
    },
    {
        image: "action-8.png",
        title: "PDF Templates",
        description: "Save time by reusing pre-saved templates for frequently used documents. Customize roles and send them to different people in just a few clicks."
    },
    {
        image: "action-9.png",
        title: "Assign to Me",
        description: 'Need to sign a document yourself? Use the "Assign to Me" feature to quickly add your signature.\n    <ul class="text-left mt-2">\n      <li>✔ One-Tap Self-Signing</li>\n      <li>✔ Fill & Sign Without Extra Steps</li>\n      <li>✔ Save & Send Instantly</li>\n    </ul>'
    }
];
const reviews = [
    {
        rating: 5,
        name: "Lisa Carter",
        designation: "Founder",
        review: "“Signing contracts on my phone has never been easier! BoloSign is fast, simple, and keeps everything organized. Total lifesaver!”",
        image: "lisa.jpg"
    },
    {
        rating: 5,
        name: "Sarah Thompson",
        designation: "CEO",
        review: "“I used to struggle with getting clients to sign documents on time. With BoloSign, it’s instant—no printing, no scanning, just tap and sign!”",
        image: "sarah.jpg"
    },
    {
        rating: 5,
        name: "James Reynolds",
        designation: "Operations Manager",
        review: "“e handle dozens of agreements daily, and BoloSign makes it effortless. Automated reminders and audit trails keep us compliant without the hassle”",
        image: "james.jpg"
    }
];
const comparisonsData = [
    {
        feature: "Pricing",
        BoloSign: "60$/Year",
        SignNow: "100$/Year",
        SignEasy: "140$/Year",
        DocuSign: "150$/Year",
        PandaDoc: "120$/Year"
    },
    {
        feature: "Forms",
        BoloSign: "Unlimited Forms",
        SignNow: false,
        SignEasy: false,
        DocuSign: false,
        PandaDoc: false
    },
    {
        feature: "PDFs",
        BoloSign: "Unlimited PDFs",
        SignNow: "Limited",
        SignEasy: "Limited",
        DocuSign: "Limited",
        PandaDoc: "Limited"
    },
    {
        feature: "PDF Templates",
        BoloSign: "Unlimited PDF Templates",
        SignNow: false,
        SignEasy: false,
        DocuSign: false,
        PandaDoc: false
    },
    {
        feature: "Collaborators",
        BoloSign: "Unlimited Collaborators",
        SignNow: "Limited",
        SignEasy: "Limited",
        DocuSign: "Limited",
        PandaDoc: "Limited"
    }
];
const faqs = [
    {
        faqQuestion: "Is BoloSign legally binding?",
        faqAnswer: "Yes, BoloSign complies with e-signature laws and regulations, ensuring your documents are legally binding. We are compliant with all the norms of UETA, ISO, HIPAA, ETA, etc."
    },
    {
        faqQuestion: "How do I place my signature on the document?",
        faqAnswer: "You can either draw your signature directly on your screen or upload a pre-saved image of your signature."
    },
    {
        faqQuestion: "What file formats does BoloSign support?",
        faqAnswer: "BoloSign supports a wide range of file formats, including PDF."
    },
    {
        faqQuestion: "If I buy a BoloSign subscription through the mobile app, can I still use the web version?",
        faqAnswer: "Yes, you can access your subscription features across any device and platform. Simply log in to <a class='underline' href='https://signature.boloforms.com/login?from=MOBILE_APP_PAGE".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_9__/* .createUTMQueryParams */ .T0)({
            from: "MOBILE_APP_PAGE"
        }), "'>https://www.boloforms.com/</a> with your username and password created on the app to access all the same great features.")
    },
    {
        faqQuestion: "On what devices does the BoloSign mobile eSignature app work?",
        faqAnswer: "The app is currently supported only on Android devices; the iOS version also will be released soon."
    }
];
const MobileNewPage = ()=>{
    const brands = [
        "BoloSign",
        "SignNow",
        "SignEasy",
        "DocuSign",
        "PandaDoc"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full relative overflow-hidden font-inter",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign App - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/mobile/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign App - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/mobile/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign App - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/mobile/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full bg-gradient-to-tr bg-indigo-600 pt-16 sm:pt-20 md:pt-32",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "w-full max-w-screen-xl px-4 lg:px-8 mx-auto flex flex-col sm:flex-row justify-between items-center sm:items-start md:items-center gap-12",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full sm:w-1/2 text-left flex flex-col gap-4 sm:gap-7 xl:gap-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-4xl md:text-5xl xl:text-7xl font-bold text-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "BoloSign -"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-1",
                                            children: "eSign App"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-xl md:text-2xl xl:text-3xl text-white",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Sign Documents Anytime, Anywhere – Fast, Secure, & Legally Binding"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-2 sm:gap-4 flex-wrap mt-4 sm:mt-0 md:mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "https://apps.apple.com/app/bolosign-upload-sign-send/id6717583531",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                // src={`${BASE_ASSETS_URL}/v2/footer/apple-store.png`}
                                                src: __webpack_require__(75995),
                                                className: "h-12 md:h-14 w-auto",
                                                width: 100,
                                                height: 100,
                                                loading: "lazy",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "https://play.google.com/store/apps/details?id=com.boloforms.signature",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                // src={`${BASE_ASSETS_URL}/v2/footer/play-store.png`}
                                                src: __webpack_require__(1873),
                                                className: "h-12 md:h-14 w-auto",
                                                width: 100,
                                                height: 100,
                                                loading: "lazy",
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "sm:w-1/2 bg-cream rounded-t-xl sm:rounded-t-3xl px-4 pt-12 pb-0 border border-zinc-300",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                // src={`${BASE_ASSETS_URL}/v2/mobile-app-page/landing-page.png`}
                                src: __webpack_require__(26386),
                                className: "w-full h-auto",
                                width: 100,
                                height: 100,
                                loading: "lazy",
                                alt: ""
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "w-full max-w-screen-xl mx-auto px-4 lg:px-8 flex flex-col gap-10 mt-20 sm:mt-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "max-w-screen-md font-bold leading-[45px] sm:leading-[55px] lg:leading-[70px] text-[36px] sm:text-[48px] lg:text-[60px]",
                        children: "Getting Started in 3 Simple Steps"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6",
                        children: gettingStarted === null || gettingStarted === void 0 ? void 0 : gettingStarted.map((item, index)=>{
                            var _item_data;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full group flex flex-col px-5 py-7 sm:p-7 gap-3 border border-gray-300 rounded-xl transition-all duration-300 ease-in-out bg-cream",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-[60px] h-[60px] bg-white rounded-full grid place-items-center",
                                                children: [
                                                    "0",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "flex-1 text-gray-800 text-xl lg:text-2xl font-bold",
                                                children: item === null || item === void 0 ? void 0 : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "font-normal text-base sm:text-lg text-gray-800 list-disc ml-6",
                                        children: item === null || item === void 0 ? void 0 : (_item_data = item.data) === null || _item_data === void 0 ? void 0 : _item_data.map((val, index)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                className: "",
                                                children: val
                                            }, index);
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "w-full max-w-screen-xl mx-auto flex flex-col justify-center items-center sm:gap-12 px-4 lg:px-8 mt-20 sm:mt-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "max-w-screen-md mx-auto text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            heading2: "See BoloSign Mobile App in action"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full flex flex-col gap-12 sm:gap-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex flex-col gap-16",
                            children: features === null || features === void 0 ? void 0 : features.map((feature, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col justify-between items-center gap-4 sm:gap-20 ".concat(index % 2 === 0 ? "sm:flex-row-reverse" : "sm:flex-row"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex flex-col gap-1 sm:gap-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    className: "text-2xl sm:text-4xl lg:text-5xl font-semibold",
                                                    children: feature.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-lg sm:text-xl lg:text-2xl",
                                                    dangerouslySetInnerHTML: {
                                                        __html: feature.description
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                // src={`${BASE_ASSETS_URL}/v2/mobile-app-page/${feature.image}`}
                                                src: __webpack_require__(18690)("./".concat(feature.image)),
                                                className: "w-full h-auto border border-gray-300 rounded-[30px]",
                                                width: 10,
                                                height: 10,
                                                alt: ""
                                            })
                                        })
                                    ]
                                }, index))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#0d0d0d] my-24 md:my-32 py-16 md:py-32",
                id: "reviews",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 md:px-8 max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-3xl sm:text-4xl md:text-5xl font-bold text-cream text-center mb-8 sm:mb-16",
                            children: "Here’s Why BoloSign Is Better To Other Alternatives"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "overflow-x-auto text-white bg-black rounded-xl no-scrollbar",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                className: "min-w-full text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    className: "text-left px-4 py-2 font-semibold",
                                                    children: "Features"
                                                }),
                                                brands.map((brand)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                        className: "px-4 py-4 text-center font-semibold ".concat(brand === "BoloSign" ? "bg-zinc-900 text-white font-bold theme-text-color" : ""),
                                                        children: brand
                                                    }, brand))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                        children: comparisonsData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                className: "border-t border-zinc-800",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        className: "px-4 py-3",
                                                        children: item.feature
                                                    }),
                                                    brands.map((brand)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                            className: "px-4 py-4 text-center ".concat(brand === "BoloSign" ? "bg-zinc-900 font-semibold" : ""),
                                                            children: item[brand] === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-zinc-300",
                                                                children: "—"
                                                            }) : item[brand] === "Limited" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-zinc-300",
                                                                children: "Limited"
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-zinc-300",
                                                                children: item[brand]
                                                            })
                                                        }, brand))
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white my-12 sm:my-24 md:my-32",
                id: "reviews",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 md:px-8 max-w-screen-xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-4xl sm:text-6xl font-bold text-black text-center",
                            children: "Join 1,000+ Users..."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 sm:gap-y-10 sm:gap-x-6 mt-12 sm:mt-16",
                            children: reviews.map((review, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full relative flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full pl-[120px] pb-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                width: 10,
                                                height: 2,
                                                // src={require(`@assets/mobile-app-page/stars.png`)}
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_8__.BASE_ASSETS_URL, "/v2/mobile-app-page/stars.png"),
                                                alt: "Stars",
                                                className: "h-10 w-auto z-20"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "h-full flex flex-col gap-2 bg-cream rounded-2xl px-4 py-6 text-gray-900",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: __webpack_require__(18690)("./".concat(review.image)),
                                                    // src={`${BASE_ASSETS_URL}/v/mobile-app-page/${review.image}`}
                                                    width: 20,
                                                    height: 20,
                                                    alt: "User",
                                                    className: "w-[120px] h-[120px] object-cover absolute rounded-full left-0 -top-[16px] border-[5px] border-white"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "text-lg md:text-xl font-semibold pl-[110px]",
                                                    children: [
                                                        review.name,
                                                        ", ",
                                                        review.designation
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-lg",
                                                        children: review.review
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "w-full max-w-screen-xl mx-auto px-4 lg:px-8 mt-20 sm:mt-32",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureLtd_Legal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    bgColor: "bg-transparent",
                    shadow: false,
                    complianceGroupImage: false
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "w-full px-4 lg:px-8 mt-20 md:mt-32 bg-gradient-clm py-12 sm:py-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "max-w-screen-lg text-white mx-auto text-center text-2xl sm:text-3xl md:text-4xl font-semibold",
                        children: "Running a business is busy enough— sign documents the easy way with BoloSign!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-center items-center gap-2 sm:gap-4 flex-wrap mt-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "https://apps.apple.com/app/bolosign-upload-sign-send/id6717583531",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    // src={`${BASE_ASSETS_URL}/v2/footer/apple-store.png`}
                                    src: __webpack_require__(75995),
                                    className: "h-12 sm:h-14 md:h-16 w-auto",
                                    width: 100,
                                    height: 100,
                                    loading: "lazy",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "https://play.google.com/store/apps/details?id=com.boloforms.signature",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    // src={`${BASE_ASSETS_URL}/v2/footer/play-store.png`}
                                    src: __webpack_require__(1873),
                                    className: "h-12 sm:h-14 md:h-16 w-auto",
                                    width: 100,
                                    height: 100,
                                    loading: "lazy",
                                    alt: ""
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "w-full max-w-screen-lg mx-auto flex flex-col justify-center items-center sm:gap-2 mt-20 sm:mt-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-left px-4 lg:px-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            heading2: "Frequently Asked Questions"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-[1000px] mx-auto flex flex-col gap-4 sm:gap-8",
                        children: faqs.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                faqQuestion: faq.faqQuestion,
                                faqAnswer: faq.faqAnswer
                            }, index))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobileNewPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1817,9774,2888,179], function() { return __webpack_exec__(89451); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);